export default __webpack_public_path__ + "static/media/Plissee 22 mm reversibel ausmessen front.efa0c989.jpg";